import api from './api';

// Workflow Stage Comments
export const listWorkflowStageComments = async (agencySlug: string, propertyId: string, workflowId: string, stageIndex: number) => {
  const res = await api.get(`/agencies/${agencySlug}/properties/${propertyId}/workflows/${workflowId}/stages/${stageIndex}/comments`);
  return res.data;
};

export const addWorkflowStageComment = async (agencySlug: string, propertyId: string, workflowId: string, stageIndex: number, text: string, author?: string) => {
  const res = await api.post(`/agencies/${agencySlug}/properties/${propertyId}/workflows/${workflowId}/stages/${stageIndex}/comments`, { text, author });
  return res.data;
};

export const editWorkflowStageComment = async (agencySlug: string, propertyId: string, workflowId: string, stageIndex: number, commentId: string, text: string) => {
  const res = await api.put(`/agencies/${agencySlug}/properties/${propertyId}/workflows/${workflowId}/stages/${stageIndex}/comments/${commentId}`, { text });
  return res.data;
};

export const deleteWorkflowStageComment = async (agencySlug: string, propertyId: string, workflowId: string, stageIndex: number, commentId: string) => {
  const res = await api.delete(`/agencies/${agencySlug}/properties/${propertyId}/workflows/${workflowId}/stages/${stageIndex}/comments/${commentId}`);
  return res.data;
};

// Workflow Task Comments
export const listWorkflowTaskComments = async (agencySlug: string, propertyId: string, workflowId: string, stageIndex: number, taskIndex: number) => {
  const res = await api.get(`/agencies/${agencySlug}/properties/${propertyId}/workflows/${workflowId}/stages/${stageIndex}/tasks/${taskIndex}/comments`);
  return res.data;
};

export const addWorkflowTaskComment = async (agencySlug: string, propertyId: string, workflowId: string, stageIndex: number, taskIndex: number, text: string, author?: string) => {
  const res = await api.post(`/agencies/${agencySlug}/properties/${propertyId}/workflows/${workflowId}/stages/${stageIndex}/tasks/${taskIndex}/comments`, { text, author });
  return res.data;
};

export const editWorkflowTaskComment = async (agencySlug: string, propertyId: string, workflowId: string, stageIndex: number, taskIndex: number, commentId: string, text: string) => {
  const res = await api.put(`/agencies/${agencySlug}/properties/${propertyId}/workflows/${workflowId}/stages/${stageIndex}/tasks/${taskIndex}/comments/${commentId}`, { text });
  return res.data;
};

export const deleteWorkflowTaskComment = async (agencySlug: string, propertyId: string, workflowId: string, stageIndex: number, taskIndex: number, commentId: string) => {
  const res = await api.delete(`/agencies/${agencySlug}/properties/${propertyId}/workflows/${workflowId}/stages/${stageIndex}/tasks/${taskIndex}/comments/${commentId}`);
  return res.data;
}; 